import React from 'react'

const Drafts = () => {
  return (
    <div className='site-info'>Site under construction...</div>
  )
}

export default Drafts